import React from 'react';
import Cart from 'product_tabs/cart/components/Cart';
import { useDispatch, useSelector } from 'react-redux';

import { buildForms } from '../pcb_fabrication/utils/builder';
import { buildProjectNumber } from 'product_tabs/cart/utils/builders';
import { deleteFabrication, validate } from '../pcb_fabrication/fabricationSlice';
// import { validatorCb } from '../pcb_fabrication/utils/validator';

import { 
  selectFabricationCurrentVariant,
  selectFabricationDataForCart, 
} from '../pcb_fabrication/selector/selectors';

const CartWrap = () => {
  const dispatch = useDispatch();

  const fabricationCurrentVariant = useSelector(selectFabricationCurrentVariant);

  const fabCleanUp = () => dispatch(deleteFabrication());
  const onFabValidate = () => dispatch(validate());

  const projectNumber = () => {
    return Spree.project_number || buildProjectNumber(`PU${fabricationCurrentVariant}`, 24)
  }

  const projectReference = () => 'usa-quickturn-pcbs';

  return (
    <Cart
      fabricationSelector={selectFabricationDataForCart}
      buildFabricationForms={buildForms}
      fabCleanUp={fabCleanUp}
      onFabValidate={onFabValidate}
      projectNumber={projectNumber}
      projectReference={projectReference}/>
  )
};

export default CartWrap;
